export default __webpack_public_path__ + "static/media/save.08906820.svg";